import { Tag } from './../../models/inModels/Tag';
import { Component } from '@angular/core';
import { ConfirmationService, LazyLoadEvent, Message, SelectItem } from 'primeng/api';
import { Router } from '@angular/router';
import { TagsService } from '../../services/tags.service';
import { DataTable } from 'primeng/primeng';
import { Location } from '@angular/common';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.css']
})
export class TagsComponent{
  items: Tag[];
  rows: SelectItem[];
  selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
  constructor(
    private service: TagsService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private location: Location) { 
      this.loading = true;
      this.rows = [];
      this.rows.push({ label: '10', value: 10 });
      this.rows.push({ label: '25', value: 25 });
      this.rows.push({ label: '50', value: 50 });
      this.selectedRows = 10;
  }
  reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
  }
  
  changeRows(event): void {
		this.load(this.rowEvent);
	}

  	load(event: LazyLoadEvent): void {
      this.loading = true;
      event.rows = this.selectedRows;
      this.rowEvent = event;
      this.service.search(event).then(
        dataPager => {
          this.items = dataPager.Data;
          this.filteredRecords = dataPager.FilteredRecords;
          this.totalRecords = dataPager.TotalRecords;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.items = [];
          this.totalRecords = 0;
          this.filteredRecords = 0;
          this.error = [];
          this.error.push({ severity: 'error', summary: 'Error', detail: error });
        }
      );
    }

  delete(tag: Tag) {
    console.log(tag);
    this.confirmationService.confirm({
      message: `Are you sure you want to delete this tag?`,
			header: 'Confirmation',
      icon: 'fa fa-trash-o',
      accept: () => {
        this.loading = true;
        this.service.delete(tag.Name).then(
          result => {
            this.loading = false;
            this.load(this.rowEvent);
          },
          error => {
            this.loading = false;
            this.error = [];
            this.error.push({ severity: 'error', summary: 'Error', detail: error });
          }
        )
      }
    })
  }
  goBack() {
		this.location.back()
	}
}



// WEBPACK FOOTER //
// ./src/app/components/tags/tags.component.ts